package devxertech.com.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.style.BaseTextStyle
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import org.jetbrains.compose.web.css.CSSLengthValue
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CommonText(
    text: String,
    color: Color? = null,
    onClick: () -> Unit = {},
    width: CSSLengthOrPercentageNumericValue = 100.percent,
    fontSize: CSSLengthNumericValue? = null,
    fontWeight: Int = 400,
    textAlign: TextAlign ?= null,
    flexWrap: FlexWrap = FlexWrap.Wrap,
    cursor: Cursor = Cursor.Default,
    marginTop: CSSLengthNumericValue = 0.px,
    marginLeft: CSSLengthNumericValue = 0.px,
    marginRight: CSSLengthNumericValue = 0.px,
    marginBottom: CSSLengthNumericValue = 0.px,
    paddingTop: CSSLengthNumericValue = 0.px,
    paddingLeft: CSSLengthNumericValue = 0.px,
    paddingRight: CSSLengthNumericValue = 0.px,
    paddingBottom: CSSLengthNumericValue = 0.px,
){
    val sitePalette =   ColorMode.current.toSitePalette()
 SpanText(text = text,
     modifier = Modifier.fontFamily(Constants.FONT_FAMILY).fontWeight(fontWeight)
         .color(color?: sitePalette.commonSecondaryButtonColor.rgb)
         .fontSize(fontSize ?: 14.px)
         .margin(bottom = marginBottom, top = marginTop, left = marginLeft, right = marginRight)
         .padding(bottom = paddingBottom, top = paddingTop, left = paddingLeft, right = paddingRight)
         .flexWrap(flexWrap)
         .onClick{onClick()}
         .cursor(cursor)
         .width(width)
         .onMouseEnter {  }
         .onMouseLeave {  }
         .textAlign(textAlign?: TextAlign.Start)
 )
}
@Composable
fun FieldTitleText(text: String, color: Color? = null, size: CSSLengthValue? = null) {
    val sitePalette = ColorMode.current.toSitePalette()

    SpanText(
        modifier = BaseTextStyle.toModifier()
            .margin(bottom = 20.px)
            .color(color ?: sitePalette.primary.rgb)
            .fontFamily(Constants.FONT_FAMILY)
            .fontSize(size ?: 21.px)
            .fontWeight(FontWeight.Normal)
            .overflow(Overflow.Hidden)
            .textOverflow(TextOverflow.Ellipsis)
            .styleModifier {
                property("display", "-webkit-box")
                property("-webkit-line-clamp", "2")
                property("line-clamp", "2")
                property("-webkit-box-orient", "vertical")
            },
        text = text
    )
}

@Composable
fun FieldTitleTextNormal(
    marginBottom: CSSLengthNumericValue? = null,
    marginTop: CSSLengthNumericValue? = null,
    textAlign: TextAlign = TextAlign.Start,
    text: String,
    color: Color? = null,
    fontSize: CSSLengthNumericValue? = null,
    isClickable: Boolean? = false,
    onClick: () -> Unit,
) {
    val sitePalette = ColorMode.current.toSitePalette()

    SpanText(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = marginBottom ?: 5.px, top = marginTop ?: 0.px)
            .color(color ?: sitePalette.textFieldTextColor.rgb)
            .fontFamily(Constants.FONT_FAMILY)
            .fontSize(fontSize ?: 12.px)
            .textAlign(textAlign)
            .fontWeight(FontWeight.Normal)
            .overflow(Overflow.Visible)
            .display(DisplayStyle.None)
            .textOverflow(TextOverflow.Ellipsis)
            .cursor(if (isClickable == true) Cursor.Pointer else Cursor.Default).onClick {
                println("text click")
                onClick()
            }
            .styleModifier {
                property(
                    "display",
                    "${if (text.isEmpty() || text.isBlank()) "none" else "-webkit-box"}"
                )
                property("-webkit-line-clamp", "2")
                property("line-clamp", "1")
                property("-webkit-box-orient", "vertical")
            },
        text = text
    )
}

@Composable
fun FieldTitleTextNormalSimple(
    text: String,
    width: CSSLengthOrPercentageNumericValue = 0.px,
    color: Color? = null,
    fontFamily: String = Constants.FONT_FAMILY,
    fontSize: CSSLengthNumericValue? = null,
    textAlign: TextAlign = TextAlign.Start,
    letterSpacing: CSSLengthNumericValue = 0.px,
    fontWeight: Int = 400,
    textTransform: TextTransform = TextTransform.None,
    onClick: () -> Unit = {},
    isClickable: Boolean? = false,
    marginTop: CSSLengthNumericValue = 0.px,
    marginLeft: CSSLengthNumericValue = 0.px,
    marginRight: CSSLengthNumericValue = 0.px,
    marginBottom: CSSLengthNumericValue = 0.px,
    paddingTop: CSSLengthNumericValue = 0.px,
    paddingLeft: CSSLengthNumericValue = 0.px,
    paddingRight: CSSLengthNumericValue = 0.px,
    paddingBottom: CSSLengthNumericValue = 0.px,
    flexWrap: FlexWrap = FlexWrap.Nowrap,
    whiteSpace: WhiteSpace = WhiteSpace.Normal,
    onMouseEnter: (() -> Unit)? = null,
    onMouseLeave: (() -> Unit)? = null,
    lineHeight: CSSLengthOrPercentageNumericValue? = null

) {
    val sitePalette = ColorMode.current.toSitePalette()
    val modifier = if (width == 0.px) Modifier else Modifier.width(width)

    SpanText(
        modifier = modifier
            .margin(bottom = marginBottom, top = marginTop, left = marginLeft, right = marginRight)
            .padding(bottom = paddingBottom, top = paddingTop, left = paddingLeft, right = paddingRight)
            .color(color ?: sitePalette.textFieldTextColor.rgb)
            .fontFamily(fontFamily)
            .fontSize(fontSize ?: 13.px)
            .fontWeight(fontWeight)
            .textAlign(textAlign)
            .flexWrap(flexWrap)
            .onMouseEnter { onMouseEnter?.invoke() }
            .onMouseLeave { onMouseLeave?.invoke() }
            .whiteSpace(whiteSpace)
            .letterSpacing(letterSpacing)
            .textTransform(textTransform)
            .let { if (lineHeight != null) it.lineHeight(lineHeight) else it }
            .cursor(if (isClickable == true) Cursor.Pointer else Cursor.Default)
            .onClick {
                println("text click")
                onClick()
            },
        text = text
    )
}
